import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Input, Select, Table, Tag, message } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import axios from 'axios';

const ParserModal = ({ visible, onCancel, vacancies, onCreateCandidate }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [parsedCandidates, setParsedCandidates] = useState([]);
  const [filteredCandidates, setFilteredCandidates] = useState([]);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [selectedVacancy, setSelectedVacancy] = useState(null);

  useEffect(() => {
    if (visible) {
      fetchParsedCandidates();
    }
  }, [visible]);

  const fetchParsedCandidates = async () => {
    setLoading(true);
    try {
      const response = await axios.get('https://dev.1ak-group.com/parser-api/parser/get-all-resumes/');
      setParsedCandidates(response.data.data || []);
      setFilteredCandidates(response.data.data || []);
    } catch (error) {
      message.error('Ошибка при загрузке кандидатов из парсера');
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    const values = form.getFieldsValue();
    const filtered = parsedCandidates.filter(candidate => {
      const titleMatch = values.title
        ? candidate.title?.toLowerCase().includes(values.title.toLowerCase())
        : true;
      const cityMatch = values.city
        ? candidate.city?.toLowerCase().includes(values.city.toLowerCase())
        : true;
      const skillsMatch = values.skills
        ? candidate.skills?.some(skill =>
          skill.toLowerCase().includes(values.skills.toLowerCase())
        )
        : true;
      return titleMatch && cityMatch && skillsMatch;
    });
    setFilteredCandidates(filtered);
  };

  const handleCreate = async () => {
    if (!selectedCandidate) {
      message.warning('Выберите кандидата');
      return;
    }
    if (!selectedVacancy) {
      message.warning('Выберите вакансию');
      return;
    }

    try {
      setLoading(true);
      await onCreateCandidate({
        vacancy_id: selectedVacancy,
        full_name: selectedCandidate.fio || 'Не указано',
        phone_number: selectedCandidate.phone_number || 'Не указан',
        resume: selectedCandidate.title || 'Резюме',
        salary_range: selectedCandidate.salary
          ? `${selectedCandidate.salary} ${selectedCandidate.salary_currency || ''}`
          : 'Не указана',
        resume_uuid: selectedCandidate.resume_uuid,
        work_permit: selectedCandidate.work_permit,
        migration: selectedCandidate.migration,
        employment: selectedCandidate.employment,
        specializations: selectedCandidate.specializations,
        salary: selectedCandidate.salary,
        salary_currency: selectedCandidate.salary_currency,
        summary_experience: selectedCandidate.summary_experience,
        experiences: selectedCandidate.experiences,
        skills: selectedCandidate.skills,
        driving_experience: selectedCandidate.driving_experience,
        about_candidate: selectedCandidate.about_candidate,
        high_education: selectedCandidate.high_education,
        additional_education: selectedCandidate.additional_education,
        examinations: selectedCandidate.examinations,
        city: selectedCandidate.city,
        citizenship: selectedCandidate.citizenship,
        email: selectedCandidate.email,
        another_contacts: selectedCandidate.another_contacts,
        languages: selectedCandidate.languages,
        status: 'new'
      });
      message.success('Кандидат успешно добавлен');
      onCancel();
    } catch (error) {
      message.error('Ошибка при добавлении кандидата');
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: 'ФИО',
      dataIndex: 'fio',
      key: 'fio',
      render: (text) => text || 'Не указано',
    },
    {
      title: 'Специализация',
      dataIndex: 'title',
      key: 'title',
      render: (text) => text || 'Не указана',
    },
    {
      title: 'Опыт',
      dataIndex: 'summary_experience',
      key: 'summary_experience',
      render: (text) => text || 'Не указан',
    },
    {
      title: 'Город',
      dataIndex: 'city',
      key: 'city',
      render: (text) => text || 'Не указан',
    },
  ];

  return (
    <Modal
      title="Добавить кандидата из парсера"
      visible={visible}
      onCancel={onCancel}
      width={1000}
      footer={[
        <Button key="back" onClick={onCancel}>
          Отмена
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={handleCreate}
        >
          Добавить кандидата
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <div style={{ display: 'flex', gap: '16px', marginBottom: '16px' }}>
          <Form.Item name="title" label="Должность" style={{ flex: 1 }}>
            <Input placeholder="Фильтр по должности" />
          </Form.Item>
          <Form.Item name="city" label="Город" style={{ flex: 1 }}>
            <Input placeholder="Фильтр по городу" />
          </Form.Item>
          <Form.Item name="skills" label="Навыки" style={{ flex: 1 }}>
            <Input placeholder="Фильтр по навыкам" />
          </Form.Item>
          <Form.Item style={{ alignSelf: 'flex-end' }}>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={handleSearch}
              loading={loading}
            >
              Поиск
            </Button>
          </Form.Item>
        </div>
      </Form>

      {/* <div style={{ marginBottom: '16px' }}>
        <Select
          style={{ width: '100%' }}
          placeholder="Выберите вакансию"
          onChange={setSelectedVacancy}
          value={selectedVacancy}
          options={(vacancies || []).map(v => ({
            value: v.id,
            label: v.job_title || v.name || v.position || 'Без названия'
          }))}
        />
      </div> */}

      <Table
        columns={columns}
        dataSource={filteredCandidates}
        rowKey="resume_uuid"
        loading={loading}
        rowSelection={{
          type: 'radio',
          selectedRowKeys: selectedCandidate ? [selectedCandidate.resume_uuid] : [],
          onChange: (_, selectedRows) => setSelectedCandidate(selectedRows[0] || null),
        }}
        scroll={{ y: 400 }}
        pagination={false}
        onRow={(record) => ({
          onClick: () => setSelectedCandidate(record),
        })}
      />

      {selectedCandidate && (
        <div style={{ marginTop: '16px', padding: '12px', border: '1px solid #d9d9d9', borderRadius: '4px' }}>
          <h4>Подробная информация:</h4>
          <p><strong>Навыки:</strong> {selectedCandidate.skills?.join(', ') || 'Не указаны'}</p>
          <p><strong>Образование:</strong> {selectedCandidate.high_education?.map(edu => JSON.parse(edu)?.specialist).join(', ') || 'Не указано'}</p>
          <p><strong>О себе:</strong> {selectedCandidate.about_candidate || 'Не указано'}</p>
        </div>
      )}
    </Modal>
  );
};

export default ParserModal;